import Inst from './src/ContextMenuInstance'
export * from './src/ContextMenuInstance'

import MenuBar from './src/MenuBar.vue';
import ContextMenu from './src/ContextMenu.vue';
import ContextMenuItem from './src/ContextMenuItem.vue';
import ContextMenuSeparator from './src/ContextMenuSeparator.vue';
import ContextMenuGroup from './src/ContextMenuGroup.vue';

export {
  ContextMenu,
  ContextMenuItem,
  ContextMenuSeparator,
  ContextMenuGroup,
  MenuBar,
}

export default Inst